<template>
  <el-container id="nav-page-plugin" class="nav-page-plugin">
    <el-main v-if="hasNav" class="nav-page-plugin__main">
      <!-- 默认激活：导航一级目录的第一个目录id字符串 -->
      <!-- <el-menu
        :default-active="activeTopFolder"
        class="nav-page-plugin__top-menu"
      >
        <el-menu-item
          :index="folder.catalogueId + ''"
          v-for="(folder, index) in navFolder"
          :key="folder.catalogueId + Math.random()"
          @click.native="toggleFolder(1, folder, index)"
          :class="topIndex === index ? 'active' : ''"
        >
          <i class="el-icon-menu"></i>
          <span
            class="nav-page-plugin__title"
            slot="title"
            :title="folder.catalogueName"
          >
            {{ folder.catalogueName }}
          </span>
        </el-menu-item>
      </el-menu> -->
      <!-- 导航二级目录的第一个目录id字符串 -->
      <!-- <el-menu
        :default-active="activeSecondFolder"
        class="nav-page-plugin__second-menu"
      >
        <el-menu-item
          :index="secondFolder.catalogueId + ''"
          v-for="(secondFolder, index) in navSecondFolder"
          :key="secondFolder.catalogueId + Math.random()"
          @click.native="toggleFolder(2, secondFolder, index)"
          :class="secondIndex === index ? 'active' : ''"
        >
          <i class="el-icon-cpu"></i>
          <span
            class="nav-page-plugin__title"
            slot="title"
            :title="secondFolder.catalogueName"
          >
            {{ secondFolder.catalogueName }}
          </span>
        </el-menu-item>
      </el-menu> -->
      <!-- 导航三级目录数据 -->
      <div class="nav-page-plugin__third-menu" ref="navPageThirdMenu">
        <ul class="a">
          <template v-for="thirdFolder in navThirdFolder">
            <li class="b" :key="thirdFolder.catalogueId + Math.random()">
              <div
                class="b2 b1 nav-page-plugin__title--3"
                :title="thirdFolder.catalogueName"
              >
                {{ thirdFolder.catalogueName }}
              </div>
            </li>
            <li
              class="b b-page"
              v-for="pageList in thirdFolder.pageList"
              :key="pageList.pageId + Math.random()"
            >
              <div
                class="c b1"
                @dblclick="openLink(pageList, thirdFolder.catalogueName)"
              >
                <img
                  class="navIcon"
                  :src="
                    require('../../assets/img/navIcons' +
                      (pageList.picUrl &&
                      pageList.picUrl.includes('.png') &&
                      !pageList.picUrl.includes('..')
                        ? pageList.picUrl
                        : '/icon1.png'))
                  "
                />
                <span
                  class="nav-page-plugin__title"
                  @dblclick.self="openLink(pageList, thirdFolder.catalogueName)"
                  :title="pageList.pageTitle"
                >
                  {{ pageList.pageTitle }}
                </span>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </el-main>
    <el-main v-else>
      <div class="nav-page-plugin__none" ref="navPageThirdMenu">
        <div>暂无导航，请切换组织！</div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { createMicroApp } from '@/config/microAppConfig.js'

import api from 'api/module/role'
import UrlParse from 'url-parse'

import _ from 'lodash'

import { mapState, mapActions } from 'vuex'

import showCurrentApp from '@/utils/showCurrentApp.js'
import setEntryUrl from '@/env/setEntryUrl.js'

import { removeNoneableItem } from '@/utils/removeNoneableItem.js'

export default {
  name: 'nav-page-plugin',
  watch: {
    updateNavPageFlag: {
      handler(newVal) {
        console.log(newVal)
        this.updateDialogVisible(newVal)
      },
      deep: true,
    },
  },
  data() {
    return {
      // 是否有导航
      hasNav: false,
      rootOrg: {},
      orgList: [],
      currentNavId: null,
      currentOrgId: null,
      current: {
        orgName: '',
        currentTopOrg: '',
      },
      clickTimeId: 100,
      navThirdIndex: null,
      urlToken: '',
      newNavPages: [],
      // 修改的目录集合
      newCatalogueParamList: [],
      // 给新增的导航设置目录id
      navPageCatalogueId: 0,
      // 新增的目录ID
      newFolderIds: [],
      newFolders: [],
      // 删除的目录id
      delFolders: [],
      delFolderParentIds: [],
      // 删除的导航page id
      delPageNavIds: [],
      // 右上侧导航
      currentNavScheme: '',
      handleCurrentNavFlag: true,
      navSchemes: [],
      // 一级目录数据
      navFolder: [],
      activeTopFolder: '',
      addTopFolderFlag: false,
      topFolderName: '',
      topIndex: null,
      // 二级目录数据
      navSecondFolder: [],
      activeSecondFolder: '',
      addSecondFolderFlag: false,
      secondFolderName: '',
      secondIndex: null,
      // 三级目录数据
      navThirdFolder: [],
      addThirdFolderFlag: false,
      thirdFolderName: '',
      // others
      dialogVisible: false,
      sitirDialogFixed: '',
      sysObjId: '',
      scheme: {
        name: '',
        options: [],
      },
      folder: {},
      secondFolder: {},
    }
  },
  computed: {
    ...mapState([
      'appsInOrgs',
      'keycloakToken',
      'appsInOrg',
      'updateNavPageFlag',
    ]),
  },
  created() {
    this.getList()
  },
  mounted() {
    const navPageThirdMenu = this.$refs.navPageThirdMenu
    navPageThirdMenu.addEventListener('wheel', this.thirdMenuScroll, false)
  },
  destroyed() {
    const navPageThirdMenu = this.$refs.navPageThirdMenu
    navPageThirdMenu.removeEventListener('wheel', this.thirdMenuScroll, false)
  },
  methods: {
    ...mapActions([
      'setCurrentPersonInfo',
      'setCurrentMicroApps',
      'setAppsInOrg',
      'setSelectOrgTree',
      'setCurrentOrg',
      'setCurrentAppAuthsInOrg',
    ]),
    openLink(page, pageMenuName) {
      const endUrl = page.pageUrl
      let microAppUrl
      const isMicroApp = this.appsInOrg.find(
        (app) =>
          app.appName === page.applicationName && app.microFrontFlag === '1'
      )
      if (isMicroApp) {
        const endUrlObj = new UrlParse(endUrl, true)
        microAppUrl = '/' + page.applicationName + endUrlObj.pathname
        console.log(endUrlObj, page, 'endUrlObj')
      }
      createMicroApp({
        ...page,
        pageUrl: isMicroApp ? microAppUrl : page.pageUrl,
      }).then(async (res) => {
        const titleParent = [
          this.navFolder.find(
            (nav) => nav.catalogueId.toString() === this.activeTopFolder
          )?.catalogueName,
          this.navSecondFolder.find(
            (nav) => nav.catalogueId.toString() === this.activeSecondFolder
          )?.catalogueName,
          pageMenuName,
        ]
        await this.$tabs.openTab({
          title: page.pageTitle,
          titleParent: titleParent,
          path: isMicroApp ? microAppUrl : page.pageUrl,
          query: {},
        })
        this.$nextTick(() => {
          showCurrentApp()
        })
        // actions.setGlobalState({ d: Date.now() })
      })
    },
    // 滚轮事件
    thirdMenuScroll(e) {
      e.preventDefault()
      const navPageThirdMenu = this.$refs.navPageThirdMenu
      if (e.wheelDelta > 0) {
        // 向上滚动
        navPageThirdMenu.scrollLeft = navPageThirdMenu.scrollLeft - 50
      }
      if (e.wheelDelta < 0) {
        // 向下滚动
        navPageThirdMenu.scrollLeft = navPageThirdMenu.scrollLeft + 50
      }
    },
    tree2list(treeList) {
      // 将树结构的列表转换为普通列表
      let list = []
      this.innerTree2list(treeList, list)
      return list
    },
    innerTree2list(treeList, list) {
      if (!treeList || !treeList.length) {
        return
      }
      for (let i = 0; i < treeList.length; i++) {
        let currentRow = treeList[i]
        let newRow = JSON.parse(JSON.stringify(currentRow))
        newRow.children = undefined
        list.push(newRow)
        this.innerTree2list(currentRow.children, list)
      }
    },
    // 拼接获取组织树
    getSelectOrgTree(data, rootId) {
      const commonOrg = [
        {
          orgName: '常用组织',
          id: null,
          children: [
            {
              orgName: '常用组织1',
            },
            {
              orgName: '常用组织2',
            },
            {
              orgName: '常用组织3',
            },
          ],
        },
      ]
      return [
        {
          orgName: '当前平台',
          id: rootId,
          //children: commonOrg.concat(data),
          children: data,
        },
      ]
    },
    // 获取所有组织
    async getList(flag) {
      await api({
        name: 'getAllOrg',
        data: {
          active: '1',
        },
        _this: this,
      }).then((response) => {
        const originOrgList = response.data.resultBody || [{}]
        this.rootOrg = {
          orgName: originOrgList[0].orgName,
          id: originOrgList[0].id,
        }
        this.orgList = originOrgList[0].children || []
        this.setSelectOrgTree(
          this.getSelectOrgTree(this.orgList, this.rootOrg.id)
        )

        const orgList = this.tree2list(originOrgList)
        this.listTotal = response.data.resultBody.total
        if (flag) {
          return false
        }
        // 选择导航方案
        const lastLoginOrgs =
          JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
        if (
          Object.prototype.toString.call(lastLoginOrgs) === '[object Array]'
        ) {
          const findCurrentOrg = lastLoginOrgs.find(
            (item) =>
              item.accountId ===
              this.keycloakToken.tokenParsed.sub
          )
          const isTruthOrgId = orgList.find(
            (org) => org.id === findCurrentOrg?.orgId
          )
          if (findCurrentOrg && isTruthOrgId) {
            this.getOrgInfo(Number(findCurrentOrg.orgId))
            return true
          }
        }
        this.getOrgInfo(this.rootOrg.id)
      })
    },
    // 通过组织id获取信息
    async getOrgInfo(id) {
      if (
        id === null ||
        id === undefined ||
        id === 'null' ||
        id === 'undefined'
      ) {
        this.hasNav = false
        return false
      }
      await api({
        name: 'getOrgById',
        data: {
          id,
        },
        _this: this,
      }).then((response) => {
        console.log(response, 'res')
        const orgInfo = response.data.resultBody
        this.current = {
          orgName: orgInfo.orgName,
          orgCode: orgInfo.orgCode,
          id: orgInfo.id,
          currentTopOrg: orgInfo.pname,
        }
        this.setCurrentOrg(this.current)

        // 存储最后登录的组织id
        const lastLoginOrgs =
          JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
        const findCurrentOrg = lastLoginOrgs.findIndex(
          (item) =>
            item.accountId === this.keycloakToken.tokenParsed.sub
        )
        if (findCurrentOrg !== -1) {
          lastLoginOrgs.splice(findCurrentOrg, 1, {
            accountId: this.keycloakToken.tokenParsed.sub,
            orgId: id,
            orgCode: orgInfo.orgCode,
            defaultAdmin: orgInfo.defaultAdmin,
          })
        } else {
          lastLoginOrgs.push({
            accountId: this.keycloakToken.tokenParsed.sub,
            orgId: id,
            orgCode: orgInfo.orgCode,
            defaultAdmin: orgInfo.defaultAdmin,
          })
        }
        localStorage.setItem('pc:lastLoginOrg', JSON.stringify(lastLoginOrgs))
        this.getNavFolderById(id)
      })
    },
    // 根据导航id获取导航目录结构
    async getNavFolderById(id) {
      const lastLoginOrgs =
        JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
      const findCurrentOrg = lastLoginOrgs.find(
        (item) =>
          item.accountId === this.keycloakToken.tokenParsed.sub
      )
      console.log(findCurrentOrg, '测试 org')
      let res = []
      console.log(res, 'res')
      await api({
        name: 'getOrgNavigationById',
        data: {
          orgId: id,
          orgCode: findCurrentOrg.orgCode,
          accId: findCurrentOrg.accountId,
        },
        _this: this,
      }).then((response) => {
        res = response
      })
      const requestRst = res.data.resultBody
      if (
        requestRst &&
        requestRst.nav &&
        requestRst.nav.catalogueList &&
        requestRst.nav.catalogueList.length > 0
      ) {
        this.hasNav = true
      } else {
        this.hasNav = false
        this.navFolder = []
        this.navSecondFolder = []
        this.navThirdFolder = []
      }
      let msg
      // 名词变更
      console.log(location.origin, '测试')
      if (
        !requestRst.navigationId &&
        !requestRst.schemeId &&
        !requestRst.nav.schemeId
      ) {
        msg = '当前组织尚未绑定导航方案！'
      } else if (
        !requestRst ||
        !requestRst.nav ||
        !requestRst.nav.catalogueList ||
        requestRst.nav.catalogueList.length <= 0
      ) {
        msg = '当前组织无任何应用，请推送应用到该组织！'
      }

      // 移除空节点
      requestRst.nav = removeNoneableItem(requestRst.nav || {})
      if (
        !requestRst?.nav?.catalogueList ||
        requestRst?.nav?.catalogueList.length === 0
      ) {
        msg = '当前组织导航为空，请添加后再试！'
        this.hasNav = true
      }

      if (msg) {
        this.$message.closeAll()
        this.$message({
          type: 'error',
          message: msg,
        })
        return false
      }

      // 获取导航方案后，存储权限结构
      this.setCurrentAppAuthsInOrg(requestRst.funcodes)
      // 存储当前账户绑定的人员信息
      this.setCurrentPersonInfo({
        perId: requestRst.perId,
        perCode: requestRst.perCode,
        perName: requestRst.perName,
      })
      // 一级
      // 处理childrenList，pagelist 2021/02/18 08:37 qiujida
      this.navFolder = requestRst.nav.catalogueList
      this.activeTopFolder = this.navFolder[0].catalogueId + ''
      this.topIndex = 0
      // 二级
      this.navSecondFolder = this.navFolder[0].childrenList
      this.activeSecondFolder =
        this.navSecondFolder && this.navSecondFolder.length > 0
          ? this.navSecondFolder[0].catalogueId + ''
          : ''
      this.secondIndex = 0
      // 三级
      this.navThirdFolder =
        this.navSecondFolder && this.navSecondFolder.length > 0
          ? this.navSecondFolder[0].childrenList
          : ''
    },
    // 切换顶级目录
    toggleFolder(level, item, index) {
      // 取消上次延时未执行的方法
      clearTimeout(this.clickTimeId)
      // 执行延迟
      this.clickTimeId = setTimeout(() => {
        // 单击逻辑
        switch (level) {
          case 1:
            // 一级
            this.activeTopFolder = this.navFolder[index].catalogueId + ''
            this.topIndex = index
            // 二级
            if (!this.navFolder[index].childrenList) {
              this.navSecondFolder = []
              this.$set(this.navFolder[index], 'childrenList', [])
            } else {
              this.navSecondFolder = this.navFolder[index].childrenList
            }
            this.activeSecondFolder = this.navSecondFolder.length
              ? this.navSecondFolder[0].catalogueId + ''
              : ''
            this.secondIndex = 0
            // 三级
            if (!this.navSecondFolder.length) {
              this.navThirdFolder = []
            } else if (!this.navSecondFolder[0].childrenList) {
              this.$set(
                this.navFolder[index].childrenList[0],
                'childrenList',
                []
              )
              this.navThirdFolder = []
            } else {
              this.navThirdFolder = this.navSecondFolder[0].childrenList
            }
            break
          case 2:
            // 二级
            this.activeSecondFolder = this.navSecondFolder.length
              ? this.navSecondFolder[index].catalogueId + ''
              : ''
            this.secondIndex = index
            // 三级
            if (!this.navSecondFolder.length) {
              this.navThirdFolder = []
            } else if (!this.navSecondFolder[index].childrenList) {
              this.navThirdFolder = []
              this.$set(
                this.navFolder[this.topIndex].childrenList[index],
                'childrenList',
                []
              )
              this.navThirdFolder = []
            } else {
              this.navThirdFolder = this.navSecondFolder[index].childrenList
            }
            break
          case 3:
            break
        }
      }, 200)
    },
    updateDialogVisible(data) {
      this.dialogVisible = data.flag
      if (data.org) {
        // 切换之钱，之前添加的目录进行删除
        this.newFolderIds = []
        this.newFolders = []
        this.newCatalogueParamList = []
        this.delFolders = []
        this.delFolderParentIds = []
        this.delPageNavIds = []
        this.navFolder = []
        this.navSecondFolder = []
        this.navThirdFolder = []
        this.getOrgInfo(data.org.id)
        const currentApps = this.appsInOrgs.find(
          (app) => app.orgId === data.org.id
        )
        console.log('哈哈哈', this.appsInOrgs)
        if (currentApps) {
          const appIdPrex = this.getAppIdPrex(data.org.id)
          console.log(appIdPrex)
          let appList = currentApps?.list || []
          this.setAppsInOrg(appList)
          appList = appList.filter((app) => app.microFrontFlag === '1')
          appList = appList.map((app) => {
            app.uiUri = app.uiUri.replace(/^null/, 'http://')
            app.sevUri = app.sevUri.replace(/^null/, 'http://')
            const entryUrl = setEntryUrl(app.uiUri, app.appName)
            return {
              ...app,
              id: app.appName,
              name: app.appName,
              entry: entryUrl,
              container: '#' + app.appName,
              activeRule: '/' + app.appName,
            }
          })
          console.log(this.$store.state.currentMicroApps, appList, '测试数据')
          const newMicroApps = _.cloneDeep(this.$store.state.currentMicroApps)
          console.log(newMicroApps.length, '哈哈哈哈')
          appList.forEach((app) => {
            const hasApp = newMicroApps.findIndex((old) => old.id === app.id)
            // 多组织下，同时存在多个组织中多个相同的应用
            console.log(hasApp, '哈哈哈哈')
            if (hasApp !== -1) {
              newMicroApps.splice(hasApp, 1, app)
            } else {
              newMicroApps.push(app)
            }
          })
          console.log(newMicroApps, '哈哈哈哈')
          // 多组织共存
          // this.setCurrentMicroApps(newMicroApps)
          this.setCurrentMicroApps(appList)
          console.log(this.$store.state.currentMicroApps)
          // 切换组织后，先存储切换后的组织，然后直接刷新，清空缓存
          this.cacheOrgBeforeReload(data)
          setTimeout(() => {
            location.reload()
          }, 100)
        }
      }
    },
    // 重加载之前，存储切换的组织id
    cacheOrgBeforeReload(data) {
      if (!data.org || !data.org.id) {
        return false
      }
      const lastLoginOrgs =
        JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
      const findCurrentOrg = lastLoginOrgs.findIndex(
        (item) =>
          item.accountId === this.keycloakToken.tokenParsed.sub
      )
      const cacheSwitchOrgInfo = {
        ...lastLoginOrgs[findCurrentOrg],
        orgId: data.org.id,
      }
      if (findCurrentOrg !== -1) {
        lastLoginOrgs.splice(findCurrentOrg, 1, cacheSwitchOrgInfo)
      }
      localStorage.setItem('pc:lastLoginOrg', JSON.stringify(lastLoginOrgs))
    },
    // 获取当前登录的组织和账户信息
    getAppIdPrex(orgId) {
      const appIdPrex =
        'orgId_' +
        orgId +
        '_accId_' +
        this.keycloakToken.tokenParsed.sub +
        '_appId_'
      return appIdPrex
    },
    // 导航跳转
    toggleNavUrl(urlData) {
      parent.postMessage(
        { flag: 'toggleNavUrl', data: JSON.stringify(urlData) },
        '*'
      )
    },
    beforeClose(done) {
      done()
    },
  },
}
</script>
<style scoped lang="scss">
* {
  user-select: none;
}
</style>
<style lang="scss" scoped>
.nav-page-plugin {
  padding: 0px;
  font-size: 14px;
  font-family: 'monospace 宋体';
  height: 100%;
  background: #fff;
  .el-button {
    padding: 6px 9px;
  }
  .el-menu-item {
    padding: 0 6px !important;
  }
  .el-header {
    background-image: linear-gradient(#3475b7, #145494);
    padding: 5px 8px;
    height: 43px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  &__headLabel {
    font-size: 14px;
  }
  &--selectOrg {
    margin-left: 6px;
  }
  &__header-left {
    color: white;
    display: flex;
    align-items: center;
  }
  &__header-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 128px;
    color: #66b1ff;
    font-size: 14px;
    font-weight: 900;
  }
  &__header-right {
    text-align: right;
    flex: 1;
  }
  &__main {
    padding: 0;
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
  }
  &__none {
    width: 100%;
    height: -webkit-fill-available;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 24px 56px;
      border-radius: 4px;
    }
  }
  &__title {
    // text-indent: 0;
    // padding-left: 6px;
    display: inline-block;
    // flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__title--3 {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-main {
    // border-top: 1px solid #585858;
    overflow: hidden;
  }
  .el-menu {
    border-right: 1px solid #e5e6f4;
    &-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      height: 32px;
      font-weight: 900;
      margin: 10px 0 10px 10px;
      box-sizing: border-box;
      color: #4c6c8c;
      i {
        color: #4c6c8c;
      }
    }
  }
  &__top-menu {
    width: 186px;
    overflow-x: hidden;
    padding: 12px 0;
    // background: linear-gradient(#ebf8fb, #8dc9e8) fixed;
    margin: 0;
    background: #fff;
    .el-menu-item {
      margin: 0;
      border-left: 6px solid #fff;
    }
    .active {
      background: #f1f5fe;
      color: #477dff;
      border-left: 6px solid #477dff;
      margin: 0;
    }
  }
  &__second-menu {
    width: 186px;
    overflow-x: hidden;
    background: #fff;
    color: #333;
    .el-menu-item {
      margin: 10px 12px;
    }
    .active {
      background: #477dff;
      color: #fff;
      border-top-left-radius: 21px;
      border: 1px solid #adc8dd;
      border-radius: 4px;
    }
  }
  &__third-menu {
    width: calc(100% - 372px);
    overflow: auto;
    overflow-y: hidden;
    ul {
      column-width: 100px;
      column-count: auto;
      column-rule: 1px solid #e5e6f4;
      margin: 20px 0;
      height: calc(100% - 40px);
      width: fit-content;
    }
  }
  &--add-folder {
    width: 64px;
  }
  .b {
    width: 186px;
    height: 32px;
    line-height: 32px;
    display: inherit;
    align-items: center;
  }
  .b-page {
    padding-left: 30px;
  }
  .c {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    padding-left: 6px;
    text-indent: 8px;
    font-size: 14px;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    &:hover {
      cursor: pointer;
      // background: #d5eaff;
      color: #477dff;
      .el-button {
        color: #477dff;
      }
    }
  }
  .b2 {
    position: relative;
  }
  .b2 {
    height: 100%;
    font-size: 14px;
    font-weight: 900;
    color: #477dff;
    padding: 0 24px;
  }
  .el-icon-error {
    z-index: 2;
    display: initial;
    position: absolute;
    top: 3px;
    right: 3px;
    color: #e2c8c8;
    transition: all 0.3s;
    &:hover {
      cursor: pointer;
      color: #ff0000;
      transition: all 0.3s;
    }
  }
  .navIcon {
    height: 49%;
    max-height: 18px;
  }
}
</style>
